const Plan = {

    // FIELDS
    "plan_name": "Plan Name",
    "image": "Image",
    "amount": "Amount",
    "days": "Validity (In Days)",
    "description": "Description",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "plan": "Plan",

    // ERROR
    "error_name": "Enter Plan Name",
    "error_image": "Select Image",
    "error_amount": "Enter Amount",
    "error_amount_positive": "Amount must be positive",
    "error_description": "Enter Description",
    "error_status": "Select Status",
    "error_days": "Enter Validity (In Days)",
    "error_days_positive": "Validity (In Days) must be positive",
    "error_days_integer": "Validity (In Days) must be an integer",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_image": "IMAGE",
    "table_amount": "AMOUNT",
    "table_days": "VALIDITY (IN DAYS)",
    "table_description": "DESCRIPTION",
    "table_status": "STATUS",

    // OTHER
    "current_image": "Current Image",

}

export default Plan;

